"use client";;
import Image from '@/app/ui/utils/Image';
import { cn, sleep, youtube_getVideoThumbnail } from '@/lib/utils';
import { sendGAEvent, YouTubeEmbed } from '@next/third-parties/google';
import { ReactNode, useState } from 'react';

export default function YoutubeEmbed_tracker({ videos }: { videos: { id: string, title: string }[] }) {
    const params = `playlist=${videos.map(v => v.id).join(",")}`;

    return <YoutubeEmbed_trackerWarper videos={ videos }>
        <YouTubeEmbed videoid={ videos[0].id } style={ "width:100%;max-width: none;" } playlabel="נגן פרק" js-api
            //@ts-expect-error nextjs didnt implemented this directly but it is an lite-yt-embed feature
            title={ videos[0].title }
            params={ `${params}&version=3&widget_referrer=https://www.nightfall.co.il&color=#85ddff&hl=he-il&listType=playlist&modestbranding=1&rel=0&title=test` } />
    </YoutubeEmbed_trackerWarper>
}

function YoutubeEmbed_trackerWarper({ videos, children }: { videos: { id: string, title: string }[], children: ReactNode }) {
    const [startedWatching, setStartedWatching] = useState(false);

    async function click() {
        sendGAEvent("event", "videoView", { "value": videos[0].id })
        await sleep(1);
        setStartedWatching(true);

    }


    return <article className='relative group/recentVideos'>
        {
            videos
                .slice(1, 4)// get latest 3 videos (beside the very first one)
                .reverse()// reverse the order to show the latest first
                .map((v, i) => <Image key={ v.id }
                    src={ youtube_getVideoThumbnail(v.id) } alt={ v.title }
                    className={ cn("aspect-video object-cover absolute rounded",
                        "shadow-md sm:shadow-lg shadow-black/70 grayscale-[0.5]", startedWatching && "shadow-none",
                        "transition-all duration-500 ease-in-out",
                        "origin-[100%_calc(100%+80svw)] group-hover/recentVideos:origin-[120%_calc(100%+100svw)]") }
                    fill
                    sizes='20vw'
                    style={ {
                        transform: `translateX(${(Math.min(3, videos.length) - i) * 1 * ~~!startedWatching}svw) scale(${1 - (Math.min(3, videos.length) - i) * 0.01 * ~~!startedWatching})`,
                    } }
                />)
        }
        <div onClick={ click } className="rounded overflow-hidden">
            { children }
        </div>
    </article>
}
